import React, { FC, useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import ROUTES from '../utils/routes'
import { StyledCountdownBanner } from '.'
import { userStore } from '../utils/UserContext'
import useAccountSubscription from './useAccountSubscription'
import { AppState } from '../../redux/root-reducer'
import { ChallengeState } from '../../redux/challenge/types'

const CountdownBanner: FC = () => {
  const { userChallenge } = useSelector<AppState, ChallengeState>((state) => state.challenge)
  const [showBanner, setShowBanner] = useState(false)
  const [showDiscount, setShowDiscount] = useState(false)

  const history = useHistory()
  const { user, loaded } = useContext(userStore)
  const isTrialUser = user?.trial && user?.stripeSubscriptionStatus === 'Active'

  const {
    periodEndsInDays,
    periodStartedInDays,
    actions: { loadSubscriptionInfo }
  } = useAccountSubscription()

  // show banner once data is done loading
  const handleLoadSubscriptionInfo = async () => {
    await loadSubscriptionInfo()
    // on the 4th day of trial, switch to discount banner
    if (periodStartedInDays > 3) {
      setShowDiscount(true)
    }
    setShowBanner(true)
  }

  useEffect(() => {
    // load subscription info if the user is an active trial user
    if (isTrialUser) {
      handleLoadSubscriptionInfo()
    }
  }, [user, loaded])

  useEffect(() => {
    if (!user?.trial) {
      setShowBanner(false)
    }
  }, [user?.trial])

  if (!showBanner || !!userChallenge) {
    return null
  }

  return (
    <StyledCountdownBanner isDiscount={showDiscount}>
      <div className="banner-content">
        <p className="banner-text">
          {showDiscount
            ? `🎉 Upgrade before your trial expires to receive 30% off your first monthly payment. Your free trial ends in ${periodEndsInDays} days.`
            : `Your free trial ends in ${periodEndsInDays} days. Sign up for a monthly or annual subscription to keep your monthly resources.`}
        </p>
        <button className="learn-more-btn" onClick={() => history.push(ROUTES.user.settings.plan)}>
          Learn More
        </button>
      </div>
    </StyledCountdownBanner>
  )
}

export default CountdownBanner
